export const CommonCardUi = ({
  feilds,
  onSave,
  onUpdate,
  onCancel,
  editbutton,
  excelUpload = false,
}) => {
  return (
    <>
      <div className="container-fluid w-100 row">
        <div className="card shadow-sm col-lg-10 col-12">
          <div className="p-2 row">{feilds}</div>
        </div>
        <div className="card d-flex flex-column row-gap-3 shadow-none border-0 col-lg-2 col-12 pt-2">
          {!editbutton && (
            <button
              disabled={editbutton}
              className="btn btn-primary text-normal"
              onClick={() => onSave()}
            >
              Save
            </button>
          )}
          {editbutton && (
            <button
              disabled={!editbutton}
              className="btn btn-info text-normal"
              onClick={() => onUpdate()}
            >
              Update
            </button>
          )}
          <button
            className="btn btn-secondary text-normal"
            onClick={() => onCancel()}
          >
            Reset
          </button>
          {excelUpload && (
            <button className="btn btn-secondary text-normal">
              Excel Upload
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export const NewCommonCardUi = ({
  feilds,
  onSave,
  onUpdate,
  onCancel,
  editbutton,
  excelUpload = false,
}) => {
  return (
    <>
      <div className="container-fluid w-100 row">
        <div className="card shadow-sm col-lg-12 col-12">
          <div className="p-2 row">{feilds}</div>
        </div>
        {/* <div className="card d-flex flex-column row-gap-3 shadow-none border-0 col-lg-2 col-12">
            <button disabled={editbutton} className="btn btn-primary text-normal" onClick={()=>onSave()}>Save</button>
            <button disabled={!editbutton} className="btn btn-info text-normal" onClick={()=>onUpdate()}>Update</button>
            <button className="btn btn-secondary text-normal" onClick={()=>onCancel()}>Cancel</button>
            {excelUpload && <button className="btn btn-secondary text-normal" >Excel Upload</button>}
        </div>   */}
      </div>
    </>
  );
};

export const InputField = (
  label,
  name,
  type,
  value,
  onchange,
  placeholder,
  col = 12,
  index = null,
  error = null,
  max = undefined,
  disabled = false,
  min = undefined
) => (
  <div className={`form-group mb-1 d-flex align-items-center col-${col}`}>
    <label className="col-4 text-verysmall" style={{ minHeight: "0px" }}>
      {label}
    </label>
    <div className="col-8">
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => {
          let inputValue = e.target.value;
          if (type === "number") {
            inputValue = inputValue.replace(/[^0-9]/g, ""); // Numbers
            if (max !== undefined && +inputValue > max) {
              inputValue = max;
            }
          }
          
          onchange({
            target: {
              name: e.target.name,
              value: e.target.value,
              ...(index !== null && { index }),
            },
          });
        }}
        className="w-100 text-verysmall"
        style={{ height: "1.5rem" }}
        max={max}
        min={min}
        disabled={disabled}
        placeholder={placeholder}
      />
      {error && <small className="text-danger mx-2">{error}</small>}
    </div>
  </div>
);

export const TextArea = (
  title,
  name,
  type,
  value,
  onchange,
  placeholder,
  col = 6,
  isObject
) => {
  return (
    <>
      <div className={`form-group col-md-${col} mb-3`}>
        <label
          htmlFor="recipient-name"
          className="col-form-label"
          style={{ fontSize: 14 }}
        >
          {title}
        </label>
        <textarea
          // className="form-control"
          className="w-100"
          placeholder={placeholder}
          name={name}
          style={{ fontSize: 14, minHeight: "70px" }}
          value={value}
          onChange={(e) => {
            if (isObject) {
              onchange({
                target: { name: e.target.name, value: e.target.value },
              });
            } else {
              onchange(e.target.value);
            }
          }}
        />
      </div>
    </>
  );
};

export const SelectField = (
  label,
  name,
  value,
  onchange,
  options = [],
  col = 12,
  index = null,
  error,
  disabled = false
) => (
  <div className={`form-group mb-1 d-flex align-items-center col-${col}`}>
    <label className="col-4 text-verysmall" style={{ minHeight: "0px" }}>
      {label}
    </label>
    <div className="col-8">
      <select
        name={name}
        value={value}
        onChange={(e) => {
          onchange({
            target: {
              name: e.target.name,
              value: e.target.value,
              ...(index !== null && { index }),
            },
          });
        }}
        className="w-100 text-verysmall"
        style={{ height: "1.5rem" }}
        disabled={disabled}
      >
        <option value="">{label}</option>
        {Array.isArray(options) &&
          options.map((option, idx) => (
            <option key={idx} value={option?.value}>
              {option?.label}
            </option>
          ))}
      </select>
      {error && <small className="text-danger mx-2">{error}</small>}
    </div>
  </div>
);

export const SelectOption = (
  label,
  name,
  value,
  onChange,
  placeholder,
  options,
  error,
  labelview = true
) => {
  const isValidValue = options.some(
    (option) =>
      option.id == value ||
      options.user_Id == value ||
      option.school_id == value ||
      option.subcategory_id == value ||
      option.manufacturer_id == value ||
      option.supplier_id == value ||
      option.customer_id == value
  );
  return (
    <div className="mb-1 d-flex align-items-center">
      {labelview && (
        <label htmlFor={name} className="form-label col-4 mb-0 text-verysmall">
          {label}
        </label>
      )}
      <div className="col-8 ">
        <select
          className="text-verysmall w-100"
          style={{ height: "1.5rem" }}
          id={name}
          name={name}
          value={isValidValue ? value : ""}
          onChange={(e) =>
            onChange({ target: { name: e.target.name, value: e.target.value } })
          }
          required
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option
              key={index}
              value={
                option.id
                  ? option.id
                  : option.subcategory_id
                  ? option.subcategory_id
                  : option.manufacturer_id
                  ? option.manufacturer_id
                  : option.supplier_id
                  ? option.supplier_id
                  : option.user_Id
                  ? option.user_Id
                  : option.customer_id
              }
            >
              {option.title
                ? option.title
                : option.from_date && option.to_date
                ? `${option.from_date}-${option.to_date}`
                : option.first_name && option.last_name
                ? `${option.first_name} ${option.last_name}`
                : option.full_name
                ? `${option.full_name}`
                : option.school_title
                ? `${option.school_title}`
                : option.Categories
                ? `${option.Categories}`
                : option.subcategory_name
                ? `${option.subcategory_name}`
                : option.name
                ? `${option.name}`
                : option.supplier_name
                ? `${option.supplier_name}`
                : ""}
            </option>
          ))}
        </select>
        {error && <small className="text-danger mx-2">{error}</small>}
      </div>
    </div>
  );
};
